var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15062_6106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 6.51074C16.5178 6.51074 16.9375 6.09101 16.9375 5.57324C16.9375 5.05548 16.5178 4.63574 16 4.63574C15.4822 4.63574 15.0625 5.05548 15.0625 5.57324C15.0625 6.09101 15.4822 6.51074 16 6.51074Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11.1468C21.4484 11.1468 24.125 5.57338 24.125 5.57338C24.125 5.57338 21.4484 0 16 0C10.5516 0 7.875 5.57338 7.875 5.57338C7.875 5.57338 10.5516 11.1468 16 11.1468ZM16 2.76087C17.5508 2.76087 18.8125 4.02256 18.8125 5.57338C18.8125 7.12419 17.5508 8.38587 16 8.38587C14.4492 8.38587 13.1875 7.12419 13.1875 5.57338C13.1875 4.02256 14.4492 2.76087 16 2.76087Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8581 5.57324L25.5338 6.25012C25.4069 6.51387 22.3581 12.7095 16 12.7095C9.64187 12.7095 6.59312 6.51387 6.46625 6.25012L6.14187 5.57324H0V27.5601H11.56L16 32.0001L20.44 27.5601H32V5.57324H25.8581ZM7.5625 23.5908H5.6875V19.4821H7.5625V23.5908ZM11.3125 23.5908H9.4375V16.3571H11.3125V23.5908ZM15.0625 23.5908H13.1875V18.2321H15.0625V23.5908ZM18.8125 23.5908H16.9375V15.7321H18.8125V23.5908ZM22.5625 23.5908H20.6875V17.6071H22.5625V23.5908ZM26.3125 23.5908H24.4375V13.8571H26.3125V23.5908Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15062_6106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.8a35834202ba68993a9b7f76fa56b606.svg";
export { ForwardRef as ReactComponent };